<div class="admin-booking-dialog">
  <div class="booking-dialog-header" mat-dialog-title>
    <div>
      <h2>Booking Form</h2>
      <p>Review your cart and enter customer details</p>
    </div>
  </div>

  <mat-dialog-content class="dialog-body">
    <section class="booking-confirm-section">
      <label class="booking-section-title">Customer Details</label>
      <div class="booking-form">
        <div class="form-field">
          <label for="firstNameInput">FIRST NAME</label>
          <input id="firstNameInput" type="text" class="custom-input" (keyup)="isReadyToBook()" [(ngModel)]="firstName" />
        </div>

        <div class="form-field">
          <label for="lastNameInput">LAST NAME</label>
          <input id="lastNameInput" type="text" class="custom-input" (keyup)="isReadyToBook()" [(ngModel)]="lastName" />
        </div>

        <div class="form-field">
          <label for="emailInput">EMAIL</label>
          <input
            id="emailInput"
            type="email"
            class="custom-input"
            name="email"
            (ngModelChange)="isReadyToBook()"
            [(ngModel)]="email"
            #emailInput="ngModel"
            required
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
          />
          <div *ngIf="emailInput.invalid && emailInput.touched" class="text-danger helper">
            Please enter a valid email address.
          </div>
        </div>

        <div class="form-field">
          <label for="phoneInputField">PHONE</label>
          <input
            id="phoneInputField"
            type="text"
            class="custom-input"
            name="phoneNumber"
            [(ngModel)]="phoneNumber"
            (ngModelChange)="isReadyToBook()"
            #phoneInput="ngModel"
            [pattern]="'^[6-9]\\d{9}$'"
            required
          />
          <div *ngIf="phoneInput.invalid && phoneInput.touched" class="text-danger helper">
            Please enter a valid 10-digit phone number.
          </div>
        </div>

        <div class="form-field form-field--full">
          <label for="notesInput">NOTES</label>
          <textarea id="notesInput" rows="2" maxlength="50" class="custom-input" (keyup)="isReadyToBook()" [(ngModel)]="notes"></textarea>
        </div>
      </div>
    </section>

    <section class="booking-confirm-section" *ngIf="selectedSlotsData?.length">
      <label class="booking-section-title">Selected Slots</label>
      <section class="selected-slots">
        <section *ngFor="let product of displaySelectedProducts" class="product-block">
          <section *ngFor="let venue of globalObject.keys(displayData[product])" class="venue-slots">
            <div class="venue-header">
              <div class="product-name">{{ product }}</div>
              <div class="venue-name">{{ venue }}</div>
            </div>

            <div *ngFor="let data of displayData[product][venue]" class="slot-row">
              <div class="slot-date">{{ getFormattedDate(data.date) }}</div>
              <div class="slot-time">{{ getFormattedTime(data.startTime) }} - {{ getFormattedTime(data.endTime) }}</div>
              <div class="slot-price" *ngIf="data.price !== 'Unavailable'">Rs. {{ data.price }}</div>
              <div class="slot-unavailable" *ngIf="data.price === 'Unavailable'">{{ data.price }}</div>
              <div class="slot-action">
                <img src="./../../assets/img/delete.svg" (click)="removeSlot(data)" class="delete-icon" alt="Remove" />
              </div>
              <div class="service-start-date" *ngIf="(data.uniqueId).toLowerCase().includes('monthly')">
                Service Start Date: {{ data.startDate }}
              </div>
            </div>
          </section>
        </section>
      </section>
    </section>

    <section class="booking-confirm-section" *ngIf="selectedAddOns.length">
      <label class="booking-section-title">Selected Add-ons</label>
      <div class="addon-cart-row" *ngFor="let item of selectedAddOns">
        <div><strong>{{ item.productName }}</strong><br />
          <span>{{ item.quantity }} × Rs. {{ item.unitPrice | number:'1.0-2' }}</span>
        </div>
        <strong>Rs. {{ item.quantity * item.unitPrice | number:'1.0-2' }}</strong>
        <button type="button" class="addon-delete-action" (click)="removeAddOn(item.productId)" [attr.aria-label]="'Delete ' + item.productName" title="Delete add-on">
          <img src="assets/img/delete.svg" width="24" height="24" alt="" aria-hidden="true" />
        </button>
      </div>
    </section>

    <section class="booking-confirm-section">
      <label class="booking-section-title">Payment</label>
      <div class="booking-form payment-form">
        <div class="form-field form-field--full">
          <label for="discountValue">DISCOUNT</label>
          <div class="discount-control">
            <input
              id="discountValue"
              type="number"
              class="custom-input discount-value"
              name="discountValue"
              [(ngModel)]="discountValue"
              (ngModelChange)="onDiscountChange()"
              #discountCtrl="ngModel"
              [min]="0"
              [max]="discountType === 'percentage' ? 100 : getSubtotal()"
              placeholder="0"
            />

            <div class="discount-toggle" role="group" aria-label="Discount type">
              <button type="button" class="toggle-btn" [class.active]="discountType === 'percentage'" (click)="setDiscountType('percentage')" aria-label="Percentage">%</button>
              <button type="button" class="toggle-btn" [class.active]="discountType === 'absolute'" (click)="setDiscountType('absolute')" aria-label="Rupees">Rs</button>
            </div>
          </div>

          <div *ngIf="!isDiscountValid()" class="text-danger helper">
            {{ discountValue < 0 ? 'Discount cannot be negative.' : (discountType === 'percentage' ? 'Percentage cannot exceed 100.' : 'Discount cannot exceed the subtotal.') }}
          </div>
        </div>

        <div class="form-field form-field--full">
          <label for="paymentMethod">PAYMENT METHOD</label>
          <select
            id="paymentMethod"
            class="custom-input"
            name="paymentMethod"
            [(ngModel)]="paymentMethod"
            (ngModelChange)="onPaymentMethodChange()"
            #paymentMethodCtrl="ngModel"
            required
          >
            <option value="cash">Cash</option>
            <option value="payNow">Pay Now</option>
            <option value="sendLink">Send Payment Link</option>
          </select>

          <div *ngIf="paymentMethodCtrl.invalid && paymentMethodCtrl.touched" class="text-danger helper">
            Please select a payment method.
          </div>
        </div>

        <div class="form-field form-field--full option-card" *ngIf="paymentMethod === 'cash'">
          <label class="form-label">PAYMENT STATUS</label>
          <div class="option-grid">
            <label class="choice-card" for="cashPaid">
              <input type="radio" id="cashPaid" name="cashPaymentStatus" [(ngModel)]="cashPaymentStatus" value="Paid" (ngModelChange)="isReadyToBook()" />
              <span>
                <strong>Paid</strong>
                <small>Cash already collected. Booking is confirmed.</small>
              </span>
            </label>

            <label class="choice-card" for="cashWaiting">
              <input type="radio" id="cashWaiting" name="cashPaymentStatus" [(ngModel)]="cashPaymentStatus" value="WaitingForPayment" (ngModelChange)="isReadyToBook()" />
              <span>
                <strong>Waiting for Payment</strong>
                <small>Slot is blocked. Mark as paid once cash is collected.</small>
              </span>
            </label>
          </div>
        </div>

        <div class="form-field form-field--full" *ngIf="paymentMethod === 'sendLink'">
          <div class="expiry-time">
            <div>
              <label for="expiryInDaysField">DURATION (IN DAYS)</label>
              <input
                id="expiryInDaysField"
                type="number"
                class="custom-input"
                name="expiryInDays"
                [(ngModel)]="expiryInDays"
                (ngModelChange)="isReadyToBook()"
                #expiryDaysCtrl="ngModel"
                [required]="paymentMethod === 'sendLink'"
                [min]="paymentMethod === 'sendLink' ? 0 : null"
                [max]="paymentMethod === 'sendLink' ? 30 : null"
              />
              <div *ngIf="expiryDaysCtrl.touched && expiryDaysCtrl.invalid" class="text-danger helper">
                <div *ngIf="expiryDaysCtrl.errors?.['required']">Duration is required when payment link is selected.</div>
                <div *ngIf="expiryDaysCtrl.errors?.['min']">Duration must be valid.</div>
                <div *ngIf="expiryDaysCtrl.errors?.['max']">Duration cannot exceed 30 days.</div>
              </div>
            </div>

            <div>
              <label for="expiryInMinField">DURATION (IN MIN)</label>
              <input
                id="expiryInMinField"
                type="number"
                class="custom-input"
                name="expiryInMin"
                [(ngModel)]="expiryInMin"
                (ngModelChange)="isReadyToBook()"
                #expiryCtrl="ngModel"
                [required]="paymentMethod === 'sendLink'"
                [min]="paymentMethod === 'sendLink' ? 10 : null"
                [max]="paymentMethod === 'sendLink' ? 1439 : null"
              />
              <div *ngIf="expiryCtrl.touched && expiryCtrl.invalid" class="text-danger helper">
                <div *ngIf="expiryCtrl.errors?.['required']">Duration is required when payment link is selected.</div>
                <div *ngIf="expiryCtrl.errors?.['min']">Duration must be at least 10 minutes.</div>
                <div *ngIf="expiryCtrl.errors?.['max']">Duration cannot exceed 1439 minutes.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="booking-confirm-section order-summary">
      <label class="booking-section-title">Order Summary</label>
      <div class="summary-row">
        <span class="summary-label">Subtotal</span>
        <span class="summary-value">Rs. {{ getSubtotal() | number:'1.0-2' }}</span>
      </div>

      <div class="summary-row" *ngIf="getDiscountAmount() > 0">
        <span class="summary-label">
          Discount
          <ng-container *ngIf="discountType === 'percentage'">({{ discountValue }}%)</ng-container>
        </span>
        <span class="summary-value discount">- Rs. {{ getDiscountAmount() | number:'1.0-2' }}</span>
      </div>

      <div class="summary-row" *ngIf="paymentMethod === 'payNow'">
        <span class="summary-label">Platform Fee</span>
        <span class="summary-value">Rs. {{ getPlatformFee() | number:'1.0-2' }}</span>
      </div>

      <div class="summary-row summary-total">
        <span class="summary-label">Total</span>
        <span class="summary-value">Rs. {{ getTotal() | number:'1.0-2' }}</span>
      </div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <button class="btn booking-cancel-action" mat-dialog-close>Cancel</button>
    <button class="btn booking-pay-action" [disabled]="disableConfirmBtn || discountCtrl.invalid || !isDiscountValid()" (click)="confirmBooking()">Confirm</button>
  </mat-dialog-actions>
</div>
